import { Tooltip } from '@mui/material'
import {
  GridActionsCellItem,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid'
import { Switch } from 'components/Switch'
import { Row } from 'react-data-grid'
import { AiOutlineEye } from 'react-icons/ai'
import { HiOutlinePencil } from 'react-icons/hi'
import * as campanhaActions from 'store/modules/backoffice/campanha/actions'
import { AiOutlineClockCircle } from 'react-icons/ai'
import { IoIosPlay, IoIosPause } from 'react-icons/io'
import { StatusAbastecimentoCampanha } from 'store/modules/backoffice/campanha/types'
import { RiFolderCloseLine } from 'react-icons/ri'
import { FiTrash } from 'react-icons/fi'

const headerTheme = 'table-header--purple'

const getIconReabastecimentoColor = (status: StatusAbastecimentoCampanha) => {
  switch (status) {
    case 'ERRO':
      return 'red'
    case 'SUCESSO':
      return 'green'
    case 'PROCESSANDO':
      return '#e1e100'
  }
}

export const COLUMNS: GridColumns<Row> = [
  {
    field: 'descricao',
    headerName: 'Descrição',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.value || ''}>
        <span className="table-cell-full">{params?.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 2,
    minWidth: 200
  },

  {
    field: 'nomeLoja',
    headerName: 'Loja',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.value || ''}>
        <span className="table-cell-full">{params?.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 3,
    minWidth: 250
  },
  {
    field: 'descricaoTipoCampanha',
    headerName: 'Tipo',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.value || ''}>
        <span className="table-cell-full">{params?.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    minWidth: 150
  },
  {
    field: 'totalCpfsDisponiveis',
    headerName: 'Disponível',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.value || ''}>
        <span className="table-cell-full">{params?.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    minWidth: 120
  },
  {
    field: 'ligacoesRecebidas',
    headerName: 'Ligações Recebidas',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params.value || ''}>
        <span className="table-cell-full">{params.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 2,
    minWidth: 150
  },
  {
    field: 'ligacoesPerdidas',
    headerName: 'Ligações Perdidas',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params.value || ''}>
        <span className="table-cell-full">{params.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 2,
    minWidth: 150
  },
  {
    field: 'cpc',
    headerName: 'CPC',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={`${params.value}` || ''}>
        <span className="table-cell-full"> {params.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 2,
    minWidth: 120
  },
  {
    field: 'conversao',
    headerName: 'Conversão',
    headerClassName: headerTheme,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={`${params.value}` || ''}>
        <span className="table-cell-full">{params.value}</span>
      </Tooltip>
    ),
    align: 'left',
    headerAlign: 'left',
    flex: 2,
    minWidth: 120
  },
  {
    field: 'actions',
    headerName: 'Ações',
    headerClassName: headerTheme,
    type: 'actions',
    align: 'left',
    minWidth: 300,
    getActions: (params: GridRowParams) => {
      const actions: JSX.Element[] = []

      if (params.row.status) {
        actions.push(
          <GridActionsCellItem
            key={`switch-${params.row.id}`}
            icon={
              <Tooltip title="Exibir/Ocultar" placement="top" arrow>
                <span>
                  <Switch
                    size="small"
                    checked={
                      params.row.vigente === false
                        ? false
                        : params.row.habilitado
                    }
                  />
                </span>
              </Tooltip>
            }
            onClick={() => {
              campanhaActions.alterarStatusCampanhaDispatchSaga(
                params.row.id,
                !params.row.habilitado
              )
            }}
            disabled={!params.row.vigente}
            label="Ativar/Inativar"
          />,
          <GridActionsCellItem
            key={`status-reabastecimento-${params.row.id}`}
            icon={
              <Tooltip
                title={
                  <div style={{ textAlign: 'center' }}>
                    <div>Total: {params.row.totalCpfs}</div>
                    <div>
                      Indisponíveis:{' '}
                      {params.row.quantidadeClientesCarteiraCampanha}
                    </div>
                    <div>
                      Total de Enriquecimentos:{' '}
                      {params.row.quantidadeClientesEnriquecidos}
                    </div>
                  </div>
                }
                placement="top"
                arrow
              >
                <span>
                  <AiOutlineClockCircle
                    color={getIconReabastecimentoColor(
                      params.row.statusCampanhaCrm
                    )}
                  />
                </span>
              </Tooltip>
            }
            label="Status Reabastecimento"
          />
        )
      }

      actions.push(
        <GridActionsCellItem
          key={params.row.id}
          icon={
            <Tooltip title="Visualizar" placement="top" arrow>
              <span>
                <AiOutlineEye />
              </span>
            </Tooltip>
          }
          onClick={() => {
            campanhaActions.visualizarCampanhaSagaDispatch(params.row.id)
          }}
          label="Visualizar"
        />
      )

      if (params.row.status) {
        actions.push(
          <GridActionsCellItem
            key={`editar-${params.row.id}`}
            icon={
              <Tooltip title="Editar" placement="top" arrow>
                <span>
                  <HiOutlinePencil />
                </span>
              </Tooltip>
            }
            onClick={() => {
              campanhaActions.editarCampanhaSagaDispatch(params.row.id)
            }}
            label="Editar"
          />
        )

        if (params.row.descricaoTipoCampanha.toUpperCase() !== 'MANUAL') {
          actions.push(
            params.row.paused ? (
              <GridActionsCellItem
                key={`start-${params.row.codigoCampanhaDiscador}`}
                icon={
                  <Tooltip title="Iniciar" placement="top" arrow>
                    <span>
                      <IoIosPlay />
                    </span>
                  </Tooltip>
                }
                onClick={() => {
                  campanhaActions.setCodigoCampanhaDiscadorDispatch(
                    params.row.codigoCampanhaDiscador
                  )
                  campanhaActions.setAcaoModalDispatch('iniciar')
                  campanhaActions.toggleModalAtivarDesativarDispatch(true)
                }}
                label="start"
              />
            ) : (
              <GridActionsCellItem
                key={`pause-${params.row.codigoCampanhaDiscador}`}
                icon={
                  <Tooltip title="Pausar" placement="top" arrow>
                    <span>
                      <IoIosPause />
                    </span>
                  </Tooltip>
                }
                onClick={() => {
                  campanhaActions.setCodigoCampanhaDiscadorDispatch(
                    params.row.codigoCampanhaDiscador
                  )
                  campanhaActions.setAcaoModalDispatch('pausar')
                  campanhaActions.toggleModalAtivarDesativarDispatch(true)
                }}
                label="pause"
              />
            )
          )
        }

        if (
          !params.row.finalized &&
          params.row.descricaoTipoCampanha.toUpperCase() !== 'MANUAL'
        ) {
          actions.push(
            <GridActionsCellItem
              key={`finalizar-${params.row.codigoCampanhaDiscador}`}
              icon={
                <Tooltip title="Finalizar" placement="top" arrow>
                  <span>
                    <RiFolderCloseLine />
                  </span>
                </Tooltip>
              }
              onClick={() => {
                campanhaActions.setCodigoCampanhaDiscadorDispatch(
                  params.row.codigoCampanhaDiscador
                )
                campanhaActions.toggleModalFinalizarDispatch(true)
              }}
              label="finalizar"
            />
          )
        }

        actions.push(
          <GridActionsCellItem
            key={`excluir-${params.row.id}`}
            icon={
              <Tooltip title="Inativar" placement="top" arrow>
                <span>
                  <FiTrash />
                </span>
              </Tooltip>
            }
            onClick={() => {
              campanhaActions.setItemSelectedIdDispatch(params.row.id)
              campanhaActions.toggleModalExclusaoDispatch(true)
            }}
            label="Deletar"
          />
        )
      }

      return actions.filter(Boolean)
    }
  }
]
